import { render, staticRenderFns } from "./not-vip.vue?vue&type=template&id=1e2cfcfa&scoped=true&"
import script from "./not-vip.vue?vue&type=script&lang=js&"
export * from "./not-vip.vue?vue&type=script&lang=js&"
import style0 from "./not-vip.vue?vue&type=style&index=0&id=1e2cfcfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2cfcfa",
  null
  
)

export default component.exports